// extracted by mini-css-extract-plugin
export default {"container":"legal-form-select_container__ALTyP","list":"legal-form-select_list__d1KHd","item":"legal-form-select_item__0ibNR","selected":"legal-form-select_selected__fJJer"};